import {Hlsjs} from './hlsjs';

export class HlsjsVod extends Hlsjs {
  isLive = false;
  isSeekable = true;

}
